module.exports = __webpack_public_path__ + "media/images/flags/kw-75152e7eac8aacb9f6934a736e79aed5.svg";